import {
  CREATE_PERSONALIZATION_LEAD_REQUEST,
  CREATING_PERSONALIZATION_LEAD_SUCCEEDED,
  CREATING_PERSONALIZATION_LEAD_FAILED,
  UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST,
  UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED,
  UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED,
  FETCHING_PERSONALIZATION_LEADS_REQUEST,
  FETCHING_PERSONALIZATION_LEADS_SUCCEDED,
  FETCHING_PERSONALIZATION_LEADS_FAILED,
  UPDATING_PERSONALIZATION_FAILED,
  UPDATING_PERSONALIZATION_SUCCEEDED,
  UPDATE_PERSONALIZATION_REQUEST,
  DELETE_PERSONALIZATION_REQUEST,
  DELETING_PERSONALIZATION_FAILED,
  DELETING_PERSONALIZATION_SUCCEEDED,
  FETCHING_PERSONALIZATION_LINKS_REQUEST,
  FETCHING_PERSONALIZATION_LINKS_SUCCEDED,
  FETCHING_PERSONALIZATION_LINKS_FAILED,
  INVALIDATE_PERSONALIZATION_LEADS,
  FETCHING_PERSONALIZATION_CONTACTS,
  FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED,
  FETCHING_PERSONALIZATION_CONTACTS_FAILED,
  CREATE_PERSONALIZED_ALIAS_REQUEST,
  CREATING_PERSONALIZED_ALIAS_SUCCEDED,
  CREATING_PERSONALIZED_ALIAS_FAILED,
  UPDATE_PERSONALIZATION_ALIAS_REQUEST,
  UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED,
  UPDATING_PERSONALIZATION_ALIAS_FAILED,
  INVALIDATE_PERSONALIZATION_LEAD_ITEMS,
  INVALIDATE_PERSONALIZATION,
  FETCHING_PERSONALISATION_FORM_FIELD_SUCCEEDED,
  FETCHING_PERSONALISATION_FORM_FIELD_REQUEST,
  FETCHING_PERSONALISATION_FORM_FIELD_FAILED,
  DELETE_CAMPAIGN_REQUEST,
  DELETE_CAMPAIGN_SUCCEEDED,
  DELETE_CAMPAIGN_FAILED,
  ENABLE_CAMPAIGN_FAILED,
  ENABLE_CAMPAIGN_SUCCEEDED,
  ENABLE_CAMPAIGN_REQUEST,
  UPDATE_CAMPAIGN_FAILED,
  UPDATE_CAMPAIGN_SUCCEEDED,
  UPDATE_CAMPAIGN_REQUEST,
  CREATE_CAMPAIGN_FAILED,
  CREATE_CAMPAIGN_SUCCEEDED,
  CREATE_CAMPAIGN_REQUEST,
  FETCH_CAMPAIGN_FAILED,
  FETCH_CAMPAIGN_SUCCEEDED,
  FETCH_CAMPAIGN_REQUEST,
  FETCH_CAMPAIGNS_FAILED,
  FETCH_CAMPAIGNS_SUCCEEDED,
  FETCH_CAMPAIGNS_REQUEST,
  FETCH_AUDIENCE_SEGMENTS_REQUEST,
  FETCH_AUDIENCE_SEGMENTS_SUCCEEDED,
  FETCH_AUDIENCE_SEGMENTS_FAILED,
  CREATE_AUDIENCE_SEGMENT_REQUEST,
  CREATE_AUDIENCE_SEGMENT_SUCCEEDED,
  CREATE_AUDIENCE_SEGMENT_FAILED,
  UPDATE_AUDIENCE_SEGMENT_REQUEST,
  UPDATE_AUDIENCE_SEGMENT_SUCCEEDED,
  UPDATE_AUDIENCE_SEGMENT_FAILED,
  UPDATE_AUDIENCE_SEGMENT_ORDER_REQUEST,
  UPDATE_AUDIENCE_SEGMENT_ORDER_SUCCEEDED,
  UPDATE_AUDIENCE_SEGMENT_ORDER_FAILED,
  DELETE_AUDIENCE_SEGMENT_REQUEST,
  DELETE_AUDIENCE_SEGMENT_SUCCEEDED,
  DELETE_AUDIENCE_SEGMENT_FAILED,
  CLONE_CAMPAIGN_REQUEST,
  CLONE_CAMPAIGN_SUCCEEDED,
  CLONE_CAMPAIGN_FAILED,
  FETCH_AUDIENCE_SEGMENT_REQUEST,
  FETCH_AUDIENCE_SEGMENT_SUCCEEDED,
  FETCH_AUDIENCE_SEGMENT_FAILED,
  SELECT_PERSONALIZATION_CAMPAIGN,
  SELECT_PERSONALIZATION_AUDIENCE_SEGMENT,
  INVALIDATE_CAMPAIGN_SELECTION,
  INVALIDATE_AUDIENCE_SEGMENT_SELECTION,
  CLONE_AUDIENCE_SEGMENT_REQUEST,
  CLONE_AUDIENCE_SEGMENT_SUCCEEDED,
  CLONE_AUDIENCE_SEGMENT_FAILED,
  UPDATE_AND_REORDER_AUDIENCE_SEGMENT_REQUEST,
  FETCH_CAMPAIGNS_SEGMENTS_REQUEST,
  FETCH_CAMPAIGNS_SEGMENTS_SUCCEEDED,
  FETCH_CAMPAIGNS_SEGMENTS_FAILED,
  INVALIDATE_CAMPAIGNS_AND_SEGMENTS
} from "constants/actionTypes";

import { createMixpanelEvent } from "actions/mixpanel";
import { getStoryboardMixpanelEventPayload } from 'services/mixpanelUtil';
import { MIXPANEL_PERSONALIZATION_LINK_GENERATED } from "constants/mixpanelEvents";
import { call, fork, put, takeEvery, select, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { createAction } from "redux-actions";
import buildUrl from "build-url";
import _ from "lodash";

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;

const PERSONALIZATION_BASE_URL = `${apiUrl}/api/2.0/personalization`;
const CAMPAIGN_API_URL = `${apiUrl}/api/2.0/campaign`;
const AUDIENCE_SEGMENT_API_URL = `${apiUrl}/api/2.0/audience_segment`;
const ALIAS_URL = `${apiUrl}/api/2.0/aliases`;
/**
 * create custom leads
*/
export const creatingPersonalizationLead = createAction(CREATE_PERSONALIZATION_LEAD_REQUEST, (storyboard, request, csvFile, callback) => {
  return {
    storyboard: storyboard,
    request: request,
    csvFile: csvFile,
    callback: callback
  }
});

export const creatingPersonalizationLeadSucceeded = createAction(
  CREATING_PERSONALIZATION_LEAD_SUCCEEDED,
  (response, csvFile) => {
    return {
      response: response,
      csvFile: csvFile
    };
  }
);

export const creatingPersonalizationLeadFailed = createAction(
  CREATING_PERSONALIZATION_LEAD_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* creatingPersonalizationLeadSaga(action) {
  const { storyboard, request, csvFile, callback } = action.payload;

  const payloadReq = {
    storyboard: storyboard,
    createContactRequests: request
  }

  const creatingPersonalizationLeadAPI = () => {
    return axios
      .post(PERSONALIZATION_BASE_URL, payloadReq)
      .then((response) => response.data);
  };

  try {
    const response = yield call(creatingPersonalizationLeadAPI);
    if (response) {

      yield put(creatingPersonalizationLeadSucceeded(response, csvFile));
      callback()
    }
  } catch (error) {
    yield put(creatingPersonalizationLeadFailed(error));
  }
}

/**
 * Update custom leads
 */
export const updatePersonalization = createAction(
  UPDATE_PERSONALIZATION_REQUEST,
  (request) => {
    return {
      request: request,
    };
  }
);

const updatingPersonalizationSucceeded = createAction(
  UPDATING_PERSONALIZATION_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const updatingPersonalizationFailed = createAction(
  UPDATING_PERSONALIZATION_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* updatingPersonalizationSaga(action) {
  const { request } = action.payload;

  const updatingPersonalizationLeadAPI = () => {
    return axios
      .put(PERSONALIZATION_BASE_URL, request)
      .then((response) => response.data);
  };

  try {
    const response = yield call(updatingPersonalizationLeadAPI);
    if (response) {
      yield put(updatingPersonalizationSucceeded(response));
    }
  } catch (error) {
    yield put(updatingPersonalizationFailed(error));
  }
}

export const fetchingPersonalizationContacts = createAction(
  FETCHING_PERSONALIZATION_CONTACTS,
  (query, page, limit) => ({
    query,
    page,
    limit,
  })
);

export const fetchingPersonalizationContactsSucceeded = createAction(
  FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

export const fetchingPersonalizationContactsFailed = createAction(
  FETCHING_PERSONALIZATION_CONTACTS_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* fetchingPersonalizationContactsSaga(action) {
  const { query, page, limit } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `/api/2.0/contacts/all?page=${page}&limit=${limit}`,
  });

  const fetchAPI = () => axios.post(url, query).then((res) => res.data);

  try {
    const response = yield call(fetchAPI);
    yield put(fetchingPersonalizationContactsSucceeded(response));
  } catch (error) {
    yield put(fetchingPersonalizationContactsFailed(error));
  }
}

/**
 * delete personalization
 */
export const deletePersonalization = createAction(
  DELETE_PERSONALIZATION_REQUEST,
  (id) => {
    return {
      id: id,
    };
  }
);

const deletingPersonalizationSucceeded = createAction(
  DELETING_PERSONALIZATION_SUCCEEDED,
  (deletedId) => {
    return {
      id: deletedId,
    };
  }
);

const deletingPersonalizationFailed = createAction(
  DELETING_PERSONALIZATION_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* deletingPersonalizationSaga(action) {
  const { id } = action.payload;

  let url = buildUrl(PERSONALIZATION_BASE_URL, {
    path: id,
  });

  const deletingPersonalizationLeadAPI = () => {
    return axios.delete(url).then((response) => response.data);
  };

  try {
    const response = yield call(deletingPersonalizationLeadAPI);
    if (response) {
      yield put(deletingPersonalizationSucceeded(id));
    }
  } catch (error) {
    yield put(deletingPersonalizationFailed(error));
  }
}

/**
 * Update personalization alias for {id}
 */
export const updatePersonalizationAliases = createAction(
  UPDATE_PERSONALIZATION_ALIAS_REQUEST,
  (lead, id, request) => {
    return {
      lead: lead,
      id: id,
      request: request,
    };
  }
);

export const updatePersonalizationAliasSucceeded = createAction(
  UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED,
  (lead, id, response) => {
    return {
      lead: lead,
      id: id,
      response: response,
    };
  }
);

export const updatePersonalizationAliasFailed = createAction(
  UPDATING_PERSONALIZATION_ALIAS_FAILED,
  (error) => {
    return error;
  }
);

function* updatePersonalizationAliasSaga(action) {
  const { lead, id, request } = action.payload;

  let url = buildUrl(ALIAS_URL, {
    path: `${id}`,
  });

  const updatePersonalizationAliasAPI = () => {
    return axios.put(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(updatePersonalizationAliasAPI);
    if (response) {
      yield put(updatePersonalizationAliasSucceeded(lead, id, response));
    }
  } catch (error) {
    yield put(updatePersonalizationAliasFailed(error));
  }
}

/**
 * upload workspace  leads
 */
export const uploadingPersonalizationLead = createAction(
  UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST,
  (storyboard, request, callback) => {
    return {
      storyboard: storyboard,
      request: request,
      callback: callback,
    };
  }
);

const uploadingPersonalizationLeadSucceeded = createAction(
  UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const uploadingPersonalizationLeadFailed = createAction(
  UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* uploadingPersonalizationLeadSaga(action) {
  const { storyboard, request, callback } = action.payload;

  const payloadReq = {
    storyboard: storyboard,
    ...request,
  };

  const uploadingPersonalizationLeadAPI = () => {
    return axios
      .post(PERSONALIZATION_BASE_URL, payloadReq)
      .then((response) => response.data);
  };

  try {
    const response = yield call(uploadingPersonalizationLeadAPI);
    if (response) {
      yield put(uploadingPersonalizationLeadSucceeded(response));
      callback();
    }
  } catch (error) {
    yield put(uploadingPersonalizationLeadFailed(error));
  }
}

/**
 * fetch personalizationleads leads
 */
export const fetchPersonalizationLead = createAction(
  FETCHING_PERSONALIZATION_LEADS_REQUEST,
  (request, page, limit) => {
    return {
      request: request,
      page: page,
      limit: limit,
    };
  }
);

const fetchingPersonalizationLeadSucceeded = createAction(
  FETCHING_PERSONALIZATION_LEADS_SUCCEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const fetchingPersonalizationLeadFailed = createAction(
  FETCHING_PERSONALIZATION_LEADS_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* fetchingPersonalizationLeadSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(PERSONALIZATION_BASE_URL, {
    path: `/all?page=${page}&limit=${limit}`,
  });

  const fetchingPersonalizationLeadAPI = () => {
    return axios.post(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(fetchingPersonalizationLeadAPI);
    if (response) {
      yield put(fetchingPersonalizationLeadSucceeded(response));
    }
  } catch (error) {
    yield put(fetchingPersonalizationLeadFailed(error));
  }
}

/**
 * create personalized links
 */
export const createPersonalizedAliases = createAction(
  CREATE_PERSONALIZED_ALIAS_REQUEST,
  (request) => {
    return {
      request: request,
    };
  }
);

export const createPersonalizedAliasSucceeded = createAction(
  CREATING_PERSONALIZED_ALIAS_SUCCEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

export const createPersonalizedAliasFailed = createAction(
  CREATING_PERSONALIZED_ALIAS_FAILED,
  (error) => {
    return error;
  }
);

function* createPersonalizedAliasSaga(action) {
  const { request } = action.payload;
  const storyboard = yield select(state => _.get(state, "storyboards.storyboard.item", null));
  const { id: storyboardId, name: storyboardName, type: storyboardType } = storyboard || {};
  
  const createPersonalizedAliasAPI = () => {
    return axios.post(ALIAS_URL, request).then((response) => response.data);
  };

  try {
    const response = yield call(createPersonalizedAliasAPI);
    if (response) {
      yield put(createPersonalizedAliasSucceeded(response));
      var mixpanelPayload = getStoryboardMixpanelEventPayload(storyboardId, storyboardName, storyboardType);
      mixpanelPayload = {
        ...mixpanelPayload,
        personalization_id: request.personalization,
        page_id: request.target,
      }
      yield put(createMixpanelEvent(MIXPANEL_PERSONALIZATION_LINK_GENERATED, mixpanelPayload));
    }
  } catch (error) {
    yield put(createPersonalizedAliasFailed(error));
  }
}

/**
 * fetch personalization form fields
*/
export const fetchPersonalizationFormField = createAction(FETCHING_PERSONALISATION_FORM_FIELD_REQUEST, (request) => {
  return request;
})

export const fetchPersonalizationFormFieldSucceeded = createAction(FETCHING_PERSONALISATION_FORM_FIELD_SUCCEEDED, (response) => {
  return response;
})

export const fetchPersonalizationFormFieldFailed = createAction(FETCHING_PERSONALISATION_FORM_FIELD_FAILED, (error) => {
  return error;
})


/**
 * fetch personalizationleads links
 */
export const fetchPersonalizationLink = createAction(
  FETCHING_PERSONALIZATION_LINKS_REQUEST,
  (id, page, limit) => {
    return {
      id: id,
      page: page,
      limit: limit,
    };
  }
);

const fetchingPersonalizationLinkSucceeded = createAction(
  FETCHING_PERSONALIZATION_LINKS_SUCCEDED,
  (id, response) => {
    return {
      id: id,
      response: response,
    };
  }
);

const fetchingPersonalizationLinkFailed = createAction(
  FETCHING_PERSONALIZATION_LINKS_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* fetchingPersonalizationLinkSaga(action) {
  const { id, page, limit } = action.payload;

  const request = {
    personalization: id,
  };

  let url = buildUrl(ALIAS_URL, {
    path: `/personalization?page=${page}&limit=${limit}`,
  });

  const fetchingPersonalizationLinkAPI = () => {
    return axios.post(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(fetchingPersonalizationLinkAPI);
    if (response) {
      yield put(fetchingPersonalizationLinkSucceeded(id, response));
    }
  } catch (error) {
    yield put(fetchingPersonalizationLinkFailed(error));
  }
}

// Fetch All Campaigns
export const fetchCampaigns = createAction(
  FETCH_CAMPAIGNS_REQUEST,
  (request, page = 0, limit = 10) => {
    return {
      request: request,
      page: page,
      limit: limit,
    };
  }
);

const fetchCampaignsSucceeded = createAction(
  FETCH_CAMPAIGNS_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const fetchCampaignsFailed = createAction(FETCH_CAMPAIGNS_FAILED, (error) => {
  return {
    error: error,
  };
});

function* fetchCampaignsSaga(action) {
  const { request, page, limit } = action.payload;
  const fetchCampaignsAPI = () => {
    const url = buildUrl(CAMPAIGN_API_URL, {
      path: `/all?page=${page}&limit=${limit}`,
    });

    return axios.post(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCampaignsAPI);
    yield put(fetchCampaignsSucceeded(response));
  } catch (error) {
    yield put(fetchCampaignsFailed(error));
  }
}

// Fetch Single Campaign
export const fetchCampaign = createAction(
  FETCH_CAMPAIGN_REQUEST,
  (campaignId) => {
    return {
      campaignId: campaignId,
    };
  }
);

const fetchCampaignSucceeded = createAction(
  FETCH_CAMPAIGN_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const fetchCampaignFailed = createAction(FETCH_CAMPAIGN_FAILED, (error) => {
  return {
    error: error,
  };
});

function* fetchCampaignSaga(action) {
  const { campaignId } = action.payload;
  const fetchCampaignAPI = () => {
    const url = buildUrl(CAMPAIGN_API_URL, {
      path: `/${campaignId}`,
    });

    return axios.get(url).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCampaignAPI);
    yield put(fetchCampaignSucceeded(response));
  } catch (error) {
    yield put(fetchCampaignFailed(error));
  }
}

// Create Campaign
export const createCampaign = createAction(
  CREATE_CAMPAIGN_REQUEST,
  (request) => {
    return {
      request: request,
    };
  }
);

const createCampaignSucceeded = createAction(
  CREATE_CAMPAIGN_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const createCampaignFailed = createAction(CREATE_CAMPAIGN_FAILED, (error) => {
  return {
    error: error,
  };
});

function* createCampaignSaga(action) {
  const { request } = action.payload;
  const createCampaignAPI = () => {
    const url = buildUrl(CAMPAIGN_API_URL);

    return axios.post(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(createCampaignAPI);
    yield put(createCampaignSucceeded(response));
  } catch (error) {
    yield put(createCampaignFailed(error));
  }
}

// Update Campaign
export const updateCampaign = createAction(
  UPDATE_CAMPAIGN_REQUEST,
  (request, callback) => {
    return {
      request: request,
      callback: callback,
    };
  }
);

const updateCampaignSucceeded = createAction(
  UPDATE_CAMPAIGN_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const updateCampaignFailed = createAction(UPDATE_CAMPAIGN_FAILED, (error) => {
  return {
    error: error,
  };
});

function* updateCampaignSaga(action) {
  const { request, callback } = action.payload;
  const updateCampaignAPI = () => {
    const url = buildUrl(CAMPAIGN_API_URL);

    return axios.put(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(updateCampaignAPI);
    yield put(updateCampaignSucceeded(response));
    callback && callback("success");
  } catch (error) {
    yield put(updateCampaignFailed(error));
    callback && callback("error");
  }
}

// Enable Campaign
export const enableCampaign = createAction(
  ENABLE_CAMPAIGN_REQUEST,
  (request, callback) => {
    return {
      request: request,
      callback: callback,
    };
  }
);

const enableCampaignSucceeded = createAction(
  ENABLE_CAMPAIGN_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const enableCampaignFailed = createAction(ENABLE_CAMPAIGN_FAILED, (error) => {
  return {
    error: error,
  };
});

function* enableCampaignSaga(action) {
  const { request, callback } = action.payload;

  const enableCampaignAPI = () => {
    const url = buildUrl(CAMPAIGN_API_URL, {
      path: `/${request.id}`,
    });

    return axios.put(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(enableCampaignAPI);
    yield put(
      enableCampaignSucceeded({
        ...response,
        id: request.id,
        enabled: request.enabled,
      })
    );
    callback && callback("success");
  } catch (error) {
    yield put(enableCampaignFailed(error));
    callback && callback("error");
  }
}

// Clone Campaign
export const cloneCampaign = createAction(
  CLONE_CAMPAIGN_REQUEST,
  (campaignId, callback) => {
    return {
      campaignId: campaignId,
      callback: callback,
    };
  }
);

const cloneCampaignSucceeded = createAction(
  CLONE_CAMPAIGN_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const cloneCampaignFailed = createAction(CLONE_CAMPAIGN_FAILED, (error) => {
  return {
    error: error,
  };
});

function* cloneCampaignSaga(action) {
  const { campaignId, callback } = action.payload;
  const cloneCampaignAPI = () => {
    const url = buildUrl(CAMPAIGN_API_URL, {
      path: `/${campaignId}/clone`,
    });

    return axios.post(url).then((response) => response.data);
  };

  try {
    const response = yield call(cloneCampaignAPI);
    yield put(cloneCampaignSucceeded(response));
    callback && callback("success");
  } catch (error) {
    yield put(cloneCampaignFailed(error));
    callback && callback("error");
  }
}

// campaign selection
export const selectCampaign = createAction(
  SELECT_PERSONALIZATION_CAMPAIGN,
  (campaign) => {
    return {
      campaign: campaign,
    };
  }
);

// Delete Campaign
export const deleteCampaign = createAction(
  DELETE_CAMPAIGN_REQUEST,
  (campaignId, callback) => {
    return {
      campaignId: campaignId,
      callback: callback,
    };
  }
);

const deleteCampaignSucceeded = createAction(
  DELETE_CAMPAIGN_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const deleteCampaignFailed = createAction(DELETE_CAMPAIGN_FAILED, (error) => {
  return {
    error: error,
  };
});

function* deleteCampaignSaga(action) {
  const { campaignId, callback } = action.payload;
  const deleteCampaignAPI = () => {
    const url = buildUrl(CAMPAIGN_API_URL, {
      path: `/${campaignId}`,
    });

    return axios.delete(url).then((response) => response.data);
  };

  try {
    const response = yield call(deleteCampaignAPI);
    yield put(deleteCampaignSucceeded({ ...response, id: campaignId }));
    callback && callback();
  } catch (error) {
    yield put(deleteCampaignFailed(error));
  }
}

// Fetch All Audience Segments
export const fetchAudienceSegments = createAction(
  FETCH_AUDIENCE_SEGMENTS_REQUEST,
  (request, page = 0, limit = 10) => {
    return {
      page: page,
      limit: limit,
      request: request,
    };
  }
);

const fetchAudienceSegmentsSucceeded = createAction(
  FETCH_AUDIENCE_SEGMENTS_SUCCEEDED,
  (response, campaignId) => {
    return {
      response: response,
      campaignId: campaignId,
    };
  }
);

const fetchAudienceSegmentsFailed = createAction(
  FETCH_AUDIENCE_SEGMENTS_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* fetchAudienceSegmentsSaga(action) {
  const { page, limit, request } = action.payload;
  const fetchAudienceSegmentsAPI = () => {
    const url = buildUrl(AUDIENCE_SEGMENT_API_URL, {
      path: `/all?page=${page}&limit=${limit}`,
    });

    return axios.post(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAudienceSegmentsAPI);
    yield put(fetchAudienceSegmentsSucceeded(response, request.campaign));
  } catch (error) {
    yield put(fetchAudienceSegmentsFailed(error));
  }
}

// select audience segment

export const selectAudienceSegment = createAction(
  SELECT_PERSONALIZATION_AUDIENCE_SEGMENT,
  (segment) => {
    return {
      segment: segment,
    };
  }
);

// Fetch Single Audience Segment
export const fetchAudienceSegment = createAction(
  FETCH_AUDIENCE_SEGMENT_REQUEST,
  (request, callback) => {
    return {
      request: request,
      callback: callback,
    };
  }
);

const fetchAudienceSegmentSucceeded = createAction(
  FETCH_AUDIENCE_SEGMENT_SUCCEEDED,
  (response, campaign) => {
    return {
      response: response,
      campaign: campaign,
    };
  }
);

const fetchAudienceSegmentFailed = createAction(
  FETCH_AUDIENCE_SEGMENT_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* fetchAudienceSegmentSaga(action) {
  const { request, callback } = action.payload;
  const fetchAudienceSegmentAPI = () => {
    const url = buildUrl(AUDIENCE_SEGMENT_API_URL, {
      path: `/${request.segment}`,
    });

    return axios.get(url).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAudienceSegmentAPI);
    yield put(fetchAudienceSegmentSucceeded(response, request.campaign));
    callback && callback(response);
  } catch (error) {
    yield put(fetchAudienceSegmentFailed(error));
  }
}

// Create Audience Segment
export const createAudienceSegment = createAction(
  CREATE_AUDIENCE_SEGMENT_REQUEST,
  (request) => {
    return {
      request: request,
    };
  }
);

const createAudienceSegmentSucceeded = createAction(
  CREATE_AUDIENCE_SEGMENT_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const createAudienceSegmentFailed = createAction(
  CREATE_AUDIENCE_SEGMENT_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* createAudienceSegmentSaga(action) {
  const { request } = action.payload;
  const createAudienceSegmentAPI = () => {
    const url = buildUrl(AUDIENCE_SEGMENT_API_URL);

    return axios.post(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(createAudienceSegmentAPI);
    yield put(createAudienceSegmentSucceeded(response));
  } catch (error) {
    yield put(createAudienceSegmentFailed(error));
  }
}

// Clone Audience Segment
export const cloneAudienceSegment = createAction(
  CLONE_AUDIENCE_SEGMENT_REQUEST,
  (segment, callback) => {
    return {
      segment: segment,
      callback: callback,
    };
  }
);

const cloneAudienceSegmentSucceeded = createAction(
  CLONE_AUDIENCE_SEGMENT_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const cloneAudienceSegmentFailed = createAction(
  CLONE_AUDIENCE_SEGMENT_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* cloneAudienceSegmentSaga(action) {
  const { segment, callback } = action.payload;

  const cloneSegmentAPI = () => {
    const url = buildUrl(AUDIENCE_SEGMENT_API_URL, {
      path: `/${segment}/clone`,
    });

    return axios.post(url).then((response) => response.data);
  };

  try {
    const response = yield call(cloneSegmentAPI);
    yield put(cloneAudienceSegmentSucceeded(response));
    callback && callback("success");
  } catch (error) {
    yield put(cloneAudienceSegmentFailed(error));
    callback && callback("error");
  }
}

const updateAudienceSegmentSucceeded = createAction(
  UPDATE_AUDIENCE_SEGMENT_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const updateAudienceSegmentFailed = createAction(
  UPDATE_AUDIENCE_SEGMENT_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

const updateAudienceSegmentOrderSucceeded = createAction(
  UPDATE_AUDIENCE_SEGMENT_ORDER_SUCCEEDED,
  (response, campaign) => {
    return {
      response: response,
      campaign: campaign,
    };
  }
);

const updateAudienceSegmentOrderFailed = createAction(
  UPDATE_AUDIENCE_SEGMENT_ORDER_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

// Delete Audience Segment
export const deleteAudienceSegment = createAction(
  DELETE_AUDIENCE_SEGMENT_REQUEST,
  (request, callback) => {
    return {
      request: request,
      callback: callback,
    };
  }
);

const deleteAudienceSegmentSucceeded = createAction(
  DELETE_AUDIENCE_SEGMENT_SUCCEEDED,
  (response, request) => {
    return {
      response: response,
      request: request,
    };
  }
);

const deleteAudienceSegmentFailed = createAction(
  DELETE_AUDIENCE_SEGMENT_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* deleteAudienceSegmentSaga(action) {
  const { request, callback } = action.payload;
  const deleteAudienceSegmentAPI = () => {
    const url = buildUrl(AUDIENCE_SEGMENT_API_URL, {
      path: `/${request?.segment}`,
    });

    return axios.delete(url).then((response) => response.data);
  };

  try {
    const response = yield call(deleteAudienceSegmentAPI);
    yield put(deleteAudienceSegmentSucceeded(response, request));
    callback && callback("success");
  } catch (error) {
    yield put(deleteAudienceSegmentFailed(error));
    callback && callback("failed");
  }
}

// Fetch All Campaigns Segments
export const fetchCampaignsSegments = createAction(
  FETCH_CAMPAIGNS_SEGMENTS_REQUEST,
  (request, page = 0, limit = 10) => {
    return {
      page: page,
      limit: limit,
      request: request,
    };
  }
);

const fetchCampaignsSegmentsSucceeded = createAction(
  FETCH_CAMPAIGNS_SEGMENTS_SUCCEEDED,
  (response) => {
    return {
      response: response,
    };
  }
);

const fetchCampaignsSegmentsFailed = createAction(
  FETCH_CAMPAIGNS_SEGMENTS_FAILED,
  (error) => {
    return {
      error: error,
    };
  }
);

function* fetchCampaignsSegmentsSaga(action) {
  const { page, limit, request } = action.payload;
  const fetchCampaignsSegmentsAPI = () => {
    const url = buildUrl(CAMPAIGN_API_URL, {
      path: `/preview/all?page=${page}&limit=${limit}`,
    });

    return axios.post(url, request).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCampaignsSegmentsAPI);
    yield put(fetchCampaignsSegmentsSucceeded(response));
  } catch (error) {
    yield put(fetchCampaignsSegmentsFailed(error));
  }
}

export const invalidatePersonalizationState = createAction(
  INVALIDATE_PERSONALIZATION_LEADS,
  (type) => {
    return {
      type: type,
    };
  }
);

export const updateAndReorderAudienceSegment = createAction(
  UPDATE_AND_REORDER_AUDIENCE_SEGMENT_REQUEST,
  (updateRequest, orderRequest, callback) => {
    return {
      updateRequest,
      orderRequest,
      callback,
    };
  }
);

function* updateAndReorderAudienceSegmentSaga(action) {
  const { updateRequest, orderRequest, callback } = action.payload;

  const updateAudienceSegmentAPI = () => {
    const url = buildUrl(AUDIENCE_SEGMENT_API_URL);
    return axios.put(url, updateRequest).then((response) => response.data);
  };

  const updateAudienceSegmentOrderAPI = () => {
    const url = buildUrl(AUDIENCE_SEGMENT_API_URL, {
      path: `/order`,
    });

    return axios.post(url, orderRequest).then((response) => response.data);
  };

  try {
    // If reorder data is present, call reorder only if update passed or was skipped
    if (orderRequest) {
      const reorderRes = yield call(updateAudienceSegmentOrderAPI);
      yield put(
        updateAudienceSegmentOrderSucceeded(reorderRes, orderRequest.campaign)
      );
    }

    // If update data is present, call update first
    if (updateRequest) {
      const updateRes = yield call(updateAudienceSegmentAPI);
      yield put(updateAudienceSegmentSucceeded(updateRes));
    }

    callback && callback("success");
  } catch (error) {
    if (
      !orderRequest ||
      (updateRequest && error.config?.url?.includes("/order") === false)
    ) {
      yield put(updateAudienceSegmentFailed(error));
    } else {
      yield put(updateAudienceSegmentOrderFailed(error));
    }
    callback && callback("error");
  }
}

function* watchUpdateAndReorderAudienceSegment() {
  yield takeLatest(
    UPDATE_AND_REORDER_AUDIENCE_SEGMENT_REQUEST,
    updateAndReorderAudienceSegmentSaga
  );
}

export const invalidatePersonalization = createAction(
  INVALIDATE_PERSONALIZATION
);

export const invalidateCampaignSelection = createAction(
  INVALIDATE_CAMPAIGN_SELECTION
);

export const invalidateCampaignSegments = createAction(
  INVALIDATE_CAMPAIGNS_AND_SEGMENTS
);

export const invalidateSegmnetSelection = createAction(
  INVALIDATE_AUDIENCE_SEGMENT_SELECTION
);

export default function* personalizationSaga() {
  yield takeEvery(
    CREATE_PERSONALIZATION_LEAD_REQUEST,
    creatingPersonalizationLeadSaga
  );
  yield takeEvery(
    FETCHING_PERSONALIZATION_CONTACTS,
    fetchingPersonalizationContactsSaga
  );
  yield takeEvery(UPDATE_PERSONALIZATION_REQUEST, updatingPersonalizationSaga);
  yield takeEvery(
    UPDATE_PERSONALIZATION_ALIAS_REQUEST,
    updatePersonalizationAliasSaga
  );
  yield takeEvery(
    UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST,
    uploadingPersonalizationLeadSaga
  );
  yield takeEvery(
    FETCHING_PERSONALIZATION_LEADS_REQUEST,
    fetchingPersonalizationLeadSaga
  );
  yield takeEvery(
    FETCHING_PERSONALIZATION_LINKS_REQUEST,
    fetchingPersonalizationLinkSaga
  );
  yield takeEvery(
    CREATE_PERSONALIZED_ALIAS_REQUEST,
    createPersonalizedAliasSaga
  );
  yield takeEvery(DELETE_PERSONALIZATION_REQUEST, deletingPersonalizationSaga);
  yield takeEvery(FETCH_CAMPAIGNS_REQUEST, fetchCampaignsSaga);
  yield takeEvery(FETCH_CAMPAIGN_REQUEST, fetchCampaignSaga);
  yield takeEvery(CREATE_CAMPAIGN_REQUEST, createCampaignSaga);
  yield takeEvery(UPDATE_CAMPAIGN_REQUEST, updateCampaignSaga);
  yield takeEvery(ENABLE_CAMPAIGN_REQUEST, enableCampaignSaga);
  yield takeEvery(DELETE_CAMPAIGN_REQUEST, deleteCampaignSaga);
  yield takeEvery(FETCH_AUDIENCE_SEGMENTS_REQUEST, fetchAudienceSegmentsSaga);
  yield takeEvery(FETCH_AUDIENCE_SEGMENT_REQUEST, fetchAudienceSegmentSaga);
  yield takeEvery(CLONE_CAMPAIGN_REQUEST, cloneCampaignSaga);
  yield takeEvery(CLONE_AUDIENCE_SEGMENT_REQUEST, cloneAudienceSegmentSaga);
  yield takeEvery(CREATE_AUDIENCE_SEGMENT_REQUEST, createAudienceSegmentSaga);
  yield takeEvery(DELETE_AUDIENCE_SEGMENT_REQUEST, deleteAudienceSegmentSaga);
  yield takeEvery(FETCH_CAMPAIGNS_SEGMENTS_REQUEST, fetchCampaignsSegmentsSaga);
  yield fork(watchUpdateAndReorderAudienceSegment);
}